@if (failed()) {
  <h2 mat-dialog-title>Your account could not be reset</h2>

  <mat-dialog-content>
    @if (stalled()) {
      <p class="body-medium">
        The reset has not started yet. Try again, or sign out and come back later.
      </p>
    } @else {
      <p class="body-medium">
        Some of your data could not be removed. Try again to finish the reset; the parts that are
        done are not repeated. If it keeps failing, contact support.
      </p>
    }
    @if (resumeFailed()) {
      <p class="error body-medium" role="alert">The reset could not be restarted. Try again.</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button color="primary" [disabled]="resuming()" (click)="signOut()">Sign out</button>
    <button mat-flat-button color="primary" [disabled]="resuming()" (click)="resume()">
      Try again
    </button>
  </mat-dialog-actions>
} @else {
  <h2 mat-dialog-title>Resetting your account</h2>

  <mat-dialog-content>
    <p class="body-medium">
      Your account's data and team members are being removed. This can take a few minutes. Please
      keep this window open.
    </p>
    <p class="body-medium">
      Once it is done, you set up your account like a new one: choose metric or imperial, and start
      with demo data or from scratch.
    </p>

    <div class="progress">
      @if (started(); as current) {
        <!-- buffer mode animates the rest of the bar, so a long step does not look stuck -->
        <mat-progress-bar
          [mode]="current.status === 'Completed' ? 'determinate' : 'buffer'"
          [value]="percentDone()"
          [bufferValue]="percentDone()"
          [attr.aria-label]="'Account reset ' + percentDone() + '% done'" />
        <p class="status body-small">
          @if (current.status === 'Finalizing') {
            Almost done: preparing your empty account…
          } @else if (current.status === 'Completed') {
            Done. Starting your new account…
          } @else if (currentSteps()) {
            Removing {{ currentSteps() }} · {{ percentDone() }}% done
          } @else {
            {{ percentDone() }}% done
          }
        </p>
        @if (current.status !== 'Completed' && secondsRunning() >= 30) {
          <p class="status body-small">
            Still working, for {{ runningFor() }} now. A large tool library takes longer to remove.
          </p>
        }
      } @else {
        <mat-progress-bar mode="indeterminate" aria-label="Starting the account reset" />
        <p class="status body-small">Starting…</p>
      }
    </div>
  </mat-dialog-content>
}
